var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M907.5,1087.6h-705a90,90,0,0,1-90-90v-705a90,90,0,0,1,90-90h315a30,30,0,0,1,0,60h-315a30,30,0,0,0-30,30v705a30,30,0,0,0,30,30h705a30,30,0,0,0,30-30v-315a30,30,0,0,1,60,0v315a90,90,0,0,1-90,90Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.5,426.72a31.36,31.36,0,0,1-8.79,21.84,29.41,29.41,0,0,1-42.43,0,31.39,31.39,0,0,1-8.78-21.84l-1-205.71L758.7,488.8a30,30,0,0,1-42.3-42.45L989.92,172.83l-212.19.82h-.16c-11.46-.05-22-5.76-27.75-15a28.2,28.2,0,0,1,0-30c5.76-9.28,16.39-15,27.91-15l263.91-1a40.52,40.52,0,0,1,4.29-.23,39.76,39.76,0,0,1,4.65.27s0,0,0,0a33.44,33.44,0,0,1,19.53,7.73l.08.06A40.49,40.49,0,0,1,1086.5,153a41.12,41.12,0,0,1-.32,5.11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open-link.160baffd719cb35e0dc5489d4a4410c9.svg";
export { ForwardRef as ReactComponent };